module.exports = __webpack_public_path__ + "img/logo-dark.2baae3d2.png";